import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, output } from '@angular/core';

import { IcTopBarComponent } from 'app/shared/components/others/top-bar';
import { QaNodesDirective, qaFor } from '@ui/qa';

@Component({
    selector: 'ic-app-frame',
    standalone: true,
    templateUrl: './_app-frame.component.html',
    styleUrl: './_app-frame.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IcTopBarComponent, QaNodesDirective],
    host: {
        'class': 'ic-app-frame',
        '[class.ic-page-wrapper]': 'legacyWrapper()',
    },
})
export class IcAppFrameComponent {
    readonly legacyWrapper = input(false);
    readonly toggle = output<void>();
    protected readonly topBarQa = qaFor(IcTopBarComponent, {
        notifications: 'notifications.inbox.open',
        markRead: 'notifications.inbox.mark-read',
        userMenu: 'session.menu.open',
        userEmail: 'session.menu.email',
        signOut: 'session.menu.sign-out',
    });
}
